const fields = {
  config: { columns: 1 },
  fields: [

    {
      name: 'reservationComment',
      label: 'Komentarz',
      type: "textarea"
    },
    {
      name: 'times',
      column: 1,
      type: 'component',
      config: { columns: 2},
    },
    {
      column: 1,
      name: 'checkinTime',
      label: 'Zameldowanie',
      type: "time",
      component: "times",
      mandatory: true,
    },
    {
      column: 2,
      name: 'checkoutTime',
      label: 'Wymeldowanie',
      type: "time",
      mandatory: true,
      component: "times"

    }
  ],
};

export default fields;
